import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { type CreditTopupLimits, DEFAULT_CREDIT_TOPUP_LIMITS, parseCreditTopupLimits } from "@/lib/credit-topup";

export function useCreditTopupLimits(enabled = true, refreshKey?: unknown): { limits: CreditTopupLimits; loaded: boolean } {
  const [limits, setLimits] = useState<CreditTopupLimits>(DEFAULT_CREDIT_TOPUP_LIMITS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    Promise.resolve(supabase.rpc("credit_topup_settings_current" as never))
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) console.error("[useCreditTopupLimits]", error.message);
        setLimits(error ? DEFAULT_CREDIT_TOPUP_LIMITS : parseCreditTopupLimits(data));
        setLoaded(true);
      })
      .catch((e: unknown) => {
        if (cancelled) return;
        console.error("[useCreditTopupLimits]", (e as Error)?.message);
        setLimits(DEFAULT_CREDIT_TOPUP_LIMITS);
        setLoaded(true);
      });
    return () => { cancelled = true; };
  }, [enabled, refreshKey]);

  return { limits, loaded };
}
